export const ContentOfRegulationsPage = () =>{
    return (
        <div>
            <h1>Content of Regulations</h1>
            <p>This page will contain the content of regulations.</p>
        </div>
    );
}